import { render, staticRenderFns } from "./DashboardIntake.vue?vue&type=template&id=50c801aa&scoped=true"
import script from "./DashboardIntake.vue?vue&type=script&lang=js"
export * from "./DashboardIntake.vue?vue&type=script&lang=js"
import style0 from "./DashboardIntake.vue?vue&type=style&index=0&id=50c801aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c801aa",
  null
  
)

export default component.exports